import React, { useState } from 'react';
import './EmploiDuTemps.css';
import DashboardHeader from '../components/DashboardHeader';
import ParentSidebar from '../components/ParentSidebar';
import { ClockIcon } from '../components/Icons';

function EmploiDuTemps() {
  const [currentWeek, setCurrentWeek] = useState('Oct 21 - 27, 2024');
  const [viewMode, setViewMode] = useState('Semaine');

  const timeSlots = [
    '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20'
  ];

  const days = [
    { name: 'Lundi', date: '21' },
    { name: 'Mardi', date: '22' },
    { name: 'Mercredi', date: '23' },
    { name: 'Jeudi', date: '24' },
    { name: 'Vendredi', date: '25' },
    { name: 'Samedi', date: '26' },
    { name: 'Dimanche', date: '27' }
  ];

  // Exemple de cours
  const courses = [
    {
      day: 0, // Lundi
      startTime: 9,
      duration: 2,
      subject: 'Français',
      badges: ['09:00', '11:00'],
      color: '#4ade80'
    },
    {
      day: 1, // Mardi
      startTime: 11,
      duration: 1,
      subject: 'Mathématique',
      badges: ['11:00'],
      color: '#f87171'
    },
    {
      day: 3, // Jeudi
      startTime: 10,
      duration: 2,
      subject: 'Education Scientifique et Technologique (écrit)',
      badges: ['10:00', '12:00'],
      color: '#fb923c'
    },
    {
      day: 4, // Vendredi
      startTime: 10,
      duration: 5,
      subject: 'Education sociale (écrit)',
      badges: ['10:00', '15:00'],
      color: '#fbbf24'
    },
    {
      day: 1, // Mardi
      startTime: 15,
      duration: 3,
      subject: 'Cleaning & Quality Craftwork (Art)',
      badges: ['15:00', '18:00'],
      color: '#a78bfa'
    },
    {
      day: 2, // Mercredi
      startTime: 15,
      duration: 3,
      subject: 'Education sociale (écrit)',
      badges: ['15:00', '18:00'],
      color: '#ec4899'
    },
    {
      day: 0, // Lundi
      startTime: 17,
      duration: 4,
      subject: 'Education Scientifique et Technologique (écrit)',
      badges: ['17:00', '21:00'],
      color: '#06b6d4'
    },
    {
      day: 4, // Vendredi
      startTime: 15,
      duration: 1,
      subject: 'Français',
      badges: ['15:00'],
      color: '#06b6d4'
    },
    {
      day: 4, // Vendredi
      startTime: 17,
      duration: 2,
      subject: 'Mathématique',
      badges: ['17:00', '19:00'],
      color: '#06b6d4'
    }
  ];

  const navigateWeek = (direction) => {
    // Logic to change week
    console.log('Navigate week:', direction);
  };

  return (
    <div className="admin-layout">
      <DashboardHeader />
      <div className="admin-container">
        <ParentSidebar activePage="emploi-du-temps" />
        <main className="parent-main">
          <div className="emploi-content">
            {/* Calendar Header */}
            <div className="calendar-header">
              <div className="calendar-nav">
                <button className="today-btn">Aujourd'hui</button>
                <div className="week-navigation">
                  <button className="nav-arrow" onClick={() => navigateWeek('prev')}>‹</button>
                  <span className="current-week">{currentWeek}</span>
                  <button className="nav-arrow" onClick={() => navigateWeek('next')}>›</button>
                </div>
              </div>

              <div className="view-modes">
                <button className={viewMode === 'Année' ? 'view-btn active' : 'view-btn'} onClick={() => setViewMode('Année')}>Année</button>
                <button className={viewMode === 'Semaine' ? 'view-btn active' : 'view-btn'} onClick={() => setViewMode('Semaine')}>Semaine</button>
                <button className={viewMode === 'Mois' ? 'view-btn active' : 'view-btn'} onClick={() => setViewMode('Mois')}>Mois</button>
                <button className={viewMode === 'Jours' ? 'view-btn active' : 'view-btn'} onClick={() => setViewMode('Jours')}>Jours</button>
              </div>
            </div>

            {/* Calendar Grid */}
            <div className="calendar-grid">
              {/* Time Column */}
              <div className="time-column">
                <div className="time-header"><ClockIcon size={20} /></div>
                {timeSlots.map((time, index) => (
                  <div key={index} className="time-slot">{time}</div>
                ))}
              </div>

              {/* Days Columns */}
              {days.map((day, dayIndex) => (
                <div key={dayIndex} className="day-column">
                  <div className="day-header">
                    <div className="day-name">{day.name}</div>
                    <div className="day-date">{day.date}</div>
                  </div>
                  <div className="day-content">
                    {/* Time slots grid */}
                    {timeSlots.map((time, timeIndex) => (
                      <div key={timeIndex} className="hour-slot"></div>
                    ))}
                    
                    {/* Courses */}
                    {courses
                      .filter(course => course.day === dayIndex)
                      .map((course, courseIndex) => (
                        <div
                          key={courseIndex}
                          className="course-block"
                          style={{
                            top: `${(course.startTime - 9) * 42}px`,
                            height: `${course.duration * 42 - 4}px`,
                            backgroundColor: course.color,
                            borderColor: course.color
                          }}
                        >
                          <div className="course-badges">
                            {course.badges.map((badge, badgeIndex) => (
                              <span key={badgeIndex} className="course-badge">{badge}</span>
                            ))}
                          </div>
                          <div className="course-subject">{course.subject}</div>
                        </div>
                      ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}

export default EmploiDuTemps;
